import { useMedicalCareContext } from "../../../../contexts/MedicalCareContext";
import { useFhirData } from "../../../../utils/useFhirData";
import { GenericTimeline } from "../GenericTimeline";
import { SocialHistoryAccordion } from "./SocialHistoryAccordion";
import { alcoholicIntakeOptions } from "./alcoholicIntakeOptions";

import { useQuestionnaireContext } from "../../../../contexts/QuestionnaireContext";
import dayjs from "dayjs";

const alcoholicTypeCodes = alcoholicIntakeOptions.map(({ code }) => code);

const socialHistoryCodes = [
  "72166-2",
  "74013-4",
  "68518-0",
  "63643-1",
  "96843-8",
  "68515-6",
  "68516-4",
  "81685-9",
  "89555-7",
  ...alcoholicTypeCodes,
];

const socialHistoryTexts = Array.from(
  new Set([
    "Tabagismo",
    "Consumo diário de álcool",
    "Frequência de consumo de álcool",
    "Tipo de droga usado na sua vida",
    "Quantas vezes você usou drogas ilícitas ou recreativas nos últimos 12 meses",
    "Dias por semana de exercício moderado a intenso",
    "Minutos de exercício moderado a intenso nos dias exercitados",
    "Tipo de atividade física",
    "Intensidade usual da atividade",
    ...alcoholicIntakeOptions.map(({ display }) => display),
    ...alcoholicIntakeOptions.map(({ label }) => label),
  ])
);

export function SocialHistory() {
  const { summaryData } = useMedicalCareContext();
  const { questionnaireDefualt } = useQuestionnaireContext();

  const observationSummary = useFhirData.extractPatientSummaryResource(
    summaryData,
    "Observation"
  )?.[0];
  const encounterSummary = useFhirData.extractPatientSummaryResource(
    summaryData,
    "Encounter"
  )?.[0];
  const filterEncounter = useFhirData?.groupObservationsByEncounter(
    observationSummary?.entry?.filter((e: any) => {
      const verifyDate = questionnaireDefualt
        ? dayjs(questionnaireDefualt?.resource?.authored).isAfter(
          e?.resource?.effectiveDateTime
        )
        : true;

      // Verifica se o código está na lista de códigos de histórico social
      const isSocialHistoryCode =
        e?.resource?.code?.coding?.[0]?.code &&
        socialHistoryCodes.includes(e?.resource?.code?.coding?.[0]?.code);

      // Verifica se o texto corresponde a algum histórico social
      const isSocialHistoryText = socialHistoryTexts.includes(
        e?.resource?.code?.text
      );

      return (isSocialHistoryCode || isSocialHistoryText) && verifyDate;
    }),
    encounterSummary
  );

  return (
    <GenericTimeline
      data={filterEncounter
        ?.filter((enc: any) =>
          questionnaireDefualt
            ? dayjs(enc?.answerDate).isAfter(
              questionnaireDefualt?.resource?.authored
            )
            : true
        )
        ?.sort((a: any, b: any) => {
          const dateA = dayjs(a?.answerDate);
          const dateB = dayjs(b?.answerDate);

          return dateB.diff(dateA);
        })}
      component={(data: any, index: number) => (
        <SocialHistoryAccordion data={data} index={index} />
      )}
    />
  );
}
